import React, { useEffect, useState } from 'react'
import FilterButton from '../../components/FilterButton';
import { useTranslate } from '../../components/TranslationText';
import LibraryFilter from '../../components/LibraryFilter';
import { filterResponsive, pageTitle, rightResponsive } from '../../common/cssclasses';
import LibraryCard from '../../components/LibraryCard';
import { getCourses } from './EahsLibraryApi/eahslibraryApi';
import ActionButton from '../../components/ActionButton';

export default function LibraryPage() {
    const { translate } = useTranslate();

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [showFilter, setShowFilter] = useState(false);
    const coursePerPage = 12;
    const [visibleCount, setVisibleCount] = useState(coursePerPage);
    const [filterObject, setFilterObj] = useState({
        title: "",
        category: "",
        DateFrom: "",
        DateTo: "",
    })

    const filter = (value) => {
        setVisibleCount(coursePerPage); // reset visible count on new filter
        setFilterObj(value);
    }

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const [courses, setCourses] = useState([]);

    useEffect(() => {
        getCourses().then(res => {
            setCourses(res)
        })
    }, []);

    const uniqueCategories = [
        ...new Set(
            courses.flatMap(item => item.category)
        )
    ];
    const categories = uniqueCategories.map((cat) => ({
        text: cat,
        label: cat,
        value: cat,
    }))

    // Filtering logic
    const filteredCourses = courses.filter((course) => {
        if (!!filterObject?.title) {
            return course?.title?.toLowerCase().includes(filterObject?.title?.toLowerCase());
        }
        if (!!filterObject?.category) {
            return course?.category?.includes(filterObject?.category);
        }
        if (!!filterObject?.DateFrom && !!filterObject?.DateTo) {
            return (
                new Date(course?.publishDate).getFullYear() >= new Date(filterObject.DateFrom).getFullYear() &&
                new Date(course?.publishDate).getFullYear() <= new Date(filterObject.DateTo).getFullYear()
            );
        }

        if (!!filterObject?.DateFrom) {
            return new Date(course?.publishDate).getFullYear() >= new Date(filterObject.DateFrom).getFullYear();
        }

        if (!!filterObject?.DateTo) {
            return new Date(course?.publishDate).getFullYear() <= new Date(filterObject.DateTo).getFullYear();
        }
        return true;
    });

    // Slice visible items
    const displayedCourses = filteredCourses.slice(0, visibleCount);

    const handleLoadMore = () => {
        setVisibleCount(prev => prev + coursePerPage);
    };

    return (
        <>
            <div className="row rtl ">
                <h2 className={pageTitle}>
                    {translate('web.eahsLibrary', 'EAHS Library')}
                </h2>
            </div>
            <div className="row ">
                {windowWidth <= 970 && (
                    <div className="col-md-4 col-sm-6 col-6 text-center d-flex justify-content-center mb-3 mx-auto">
                        <FilterButton onClick={() => { setShowFilter(!showFilter) }} />
                    </div>
                )}
                <div className={filterResponsive}
                    style={{
                        display: windowWidth >= 768 ? 'block' : showFilter ? 'block' : 'none',
                    }}>
                    <LibraryFilter onSubmit={filter} categories={categories} />
                </div>

                <div className={rightResponsive}>
                    <div className="row rtl">
                        {displayedCourses.length > 0 ? (
                            displayedCourses.map((item, index) => (
                                <LibraryCard index={index} key={index} item={item} />
                            ))
                        ) : (
                            <div className="text-center bold color-eahsred">
                                {translate('web.nodataFound', 'No News Found with Your Filter Parameters')}
                            </div>
                        )}
                    </div>

                    {/* Load More button */}
                    {visibleCount < filteredCourses.length && (
                        <div className="d-flex justify-content-center align-items-center mt-3">
                            <ActionButton
                                label={translate('web.showMore', 'Show More')}
                                type={'loadmore'}
                                onClick={handleLoadMore}
                            />
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}
